var __TEMP__ = require('./_createMathOperation.js');var createMathOperation = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Multiply two numbers.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {number} multiplier The first number in a multiplication.
 * @param {number} multiplicand The second number in a multiplication.
 * @returns {number} Returns the product.
 * @example
 *
 * _.multiply(6, 4);
 * // => 24
 */
var multiply = createMathOperation(function(multiplier, multiplicand) {
  return multiplier * multiplicand;
}, 1);

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = multiply;
